<template>
        <div class="modal fade" id="supplier-create-modal-supplier" tabindex="-1" aria-labelledby="supplier-create-modal-supplier" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$t('create_supplier')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div class="modal-body" style="text-align:left">
                    <div class="supplier-form-fields">
                        <div class="supplier-form-field">
                            <label for="labelInput" class="form-label">{{$t('label')}}</label>
                            <input v-model="supplier.name"  type="string" class="form-control" id="labelInput" >
                        </div>
                        <div v-if="isSupplierFieldVisible('email')" class="supplier-form-field">
                            <label for="emailInput" class="form-label">{{$t('email')}}</label>
                            <input v-model="supplier.email"  type="string" class="form-control" id="emailInput" >
                        </div>
                        <div v-if="isSupplierFieldVisible('phone')" class="supplier-form-field">
                            <label for="phoneInput" class="form-label">{{$t('phone')}}</label>
                            <input v-model="supplier.phone"  type="string" class="form-control" id="phoneInput" >
                        </div>

                        <div v-if="isSupplierFieldVisible('city')" class="supplier-form-field">
                            <label for="cityInput" class="form-label">{{$t('city')}}</label>
                            <input v-model="supplier.city" type="string" class="form-control" id="cityInput" >
                        </div>
                        <div v-if="isSupplierFieldVisible('state')" class="supplier-form-field">
                            <label for="stateInput" class="form-label">{{$t('state')}}</label>
                            <input v-model="supplier.state" type="string" class="form-control" id="stateInput">
                        </div>
                        <div v-if="isSupplierFieldVisible('zip_code')" class="supplier-form-field">
                            <label for="zipCodeInput" class="form-label">{{$t('zip_code')}}</label>
                            <input v-model="supplier.zip_code" type="string" class="form-control" id="zipCodeInput">
                        </div>
                        <div v-if="isSupplierFieldVisible('country')" class="supplier-form-field">
                            <label for="countryInput" class="form-label">{{$t('country')}}</label>
                            <input v-model="supplier.country" type="string" class="form-control" id="countryInput">
                        </div>
                        <div v-if="isSupplierFieldVisible('tax_id')" class="supplier-form-field">
                            <label for="taxIdInput" class="form-label">{{$t('tax_id')}}</label>
                            <input v-model="supplier.tax_id" type="string" class="form-control" id="taxIdInput">
                        </div>
                        <div v-if="isSupplierFieldVisible('vat_number')" class="supplier-form-field">
                            <label for="vatNumberInput" class="form-label">{{$t('vat_number')}}</label>
                            <input v-model="supplier.vat_number" type="string" class="form-control" id="vatNumberInput" >
                        </div>

                        <div v-if="isSupplierFieldVisible('address')" class="supplier-form-field supplier-form-field--full">
                            <label for="addressInput" class="form-label">{{$t('address')}}</label>
                            <textarea v-model="supplier.address" class="form-control" id="addressInput" rows="1"></textarea>
                        </div>
                        <div v-if="isSupplierFieldVisible('notes')" class="supplier-form-field supplier-form-field--full">
                            <collapsible-notes-field v-model="supplier.notes" id="supplier-notes" rows="1" />
                        </div>
                        
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                    <button type="button" class="btn btn-success" :disabled="loading || !isFormValid" @click="save"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}</button>
                </div>
                </div>
            </div>
        </div>
</template>

<script>
import helper from '../helper'
import { getCrmSupplierFormFieldDefaults } from '../constants/crmSupplierFormFields'
export default {
  name: 'SupplierCompo',
  props : ['state'],
  data(){
    return {
        search : '',
        count : 0,
        suppliers : [],
        supplier : {
            id : null,
            name : '',
            email : '',
            phone : '',
            address : '',
            notes : '',
            city: '',
            state: '',
            zip_code: '',
            country: '',
            tax_id: '',
            vat_number: ''
        },
        createModal : null,
        editModal : null,
        loading : false
    }
  },
  computed: {
    business() {
        return this.$store.getters.BUSINESS
    },
    supplierFormFields() {
        return {
            ...getCrmSupplierFormFieldDefaults(),
            ...(this.business?.metadata?.crm_supplier_form_fields || {}),
            name: true
        }
    },
    isFormValid() {
        const hasRequiredPhone = !this.isSupplierFieldVisible('phone') || !!this.supplier.phone
        const hasValidEmail = !this.isSupplierFieldVisible('email') || !this.supplier.email || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.supplier.email)
        return !!this.supplier.name && hasRequiredPhone && hasValidEmail
    }
  },
  mounted(){

    // eslint-disable-next-line no-undef
    this.createModal = new bootstrap.Modal(document.getElementById('supplier-create-modal-supplier'))
    if(this.state === true){
       this.createModal.show()
    }

    document.getElementById('supplier-create-modal-supplier').addEventListener('hidden.bs.modal', () => { 
        this.$emit('createSupplier',{state : false })
    })

  },
  methods : {
    isSupplierFieldVisible(field) {
        return this.supplierFormFields[field] !== false
    },
    create(){
        this.clearForm()

        // eslint-disable-next-line no-undef
        this.createModal.show()
    },
    async save(){
        try{
            this.loading = true
            const response = await helper.customPost(`${process.env.VUE_APP_API}/suppliers`,this.supplier,{showToast:true})
            this.loading = false
            this.clearForm()
            this.$emit('createSupplier',{supplier : response.data, state : false })
            this.createModal.hide()
        }catch(error){
            this.loading = false
        }

    },
    clearForm(){
        this.supplier = {
            id : null,
            name : '',
            email : '',
            phone : '',
            address : '',
            notes : '',
            city: '',
            state: '',
            zip_code: '',
            country: '',
            tax_id: '',
            vat_number: ''
        }
    },
    //helper functions
    formatDate(date) { return helper.formatDate(date) }
  }
}
</script>

<style scoped>
.supplier-form-fields {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
}

.supplier-form-field {
    flex: 1 1 13rem;
    min-width: 0;
}

.supplier-form-field--full {
    flex-basis: 100%;
}
</style>
